import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import WPlusFullLogo from 'icons/w-plus/WPlusFullLogo';

const useStyles = makeStyles(() => ({
  notchSvg: {
    position: 'relative',
    width: '100%',
    flexShrink: 0,
  },
  logo: {
    position: 'absolute',
    top: 12,
    left: 0,
    right: 0,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
}));

export default function WPlusNotchBanner({ className }) {
  const classes = useStyles();

  return (
    <Box className={`${classes.notchSvg} ${className || ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="45"
        viewBox="0 0 1440 45"
        fill="none"
        preserveAspectRatio="none"
        display="block">
        <g opacity="0.5">
          <path d="M977.247 31H1441V0H-1V31H465.753C468.127 31 470.378 32.055 471.898 33.8789L477.102 40.1211C478.622 41.945 480.873 44 483.247 44H959.753C962.127 44 964.379 41.945 965.898 40.1211L971.102 33.8789C972.621 32.055 974.873 31 977.247 31Z" fill="#F9F9F9" />
          <path d="M1441.5 -0.5V31.5H977.247C975.021 31.5 972.91 32.4892 971.485 34.1992L966.282 40.4414C965.507 41.3721 964.532 42.3775 963.435 43.1533C962.34 43.9265 961.083 44.5 959.753 44.5H483.247C481.917 44.5 480.66 43.9265 479.565 43.1533C478.468 42.3775 477.493 41.3721 476.718 40.4414L471.515 34.1992C470.09 32.4892 467.979 31.5 465.753 31.5H-1.5V-0.5H1441.5Z" stroke="black" stroke-opacity="0.1" />
        </g>
      </svg>
      <Box className={classes.logo}>
        <WPlusFullLogo />
      </Box>
    </Box>
  );
}
